import { render } from "./PlayerNames.vue?vue&type=template&id=6d97dae8"
import script from "./PlayerNames.vue?vue&type=script&lang=js"
export * from "./PlayerNames.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__